import { type FetchLimitLedgerRemainingParams } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

import { fetchLimitLedgerRemaining } from '../api';

/**
 * @params FetchLimitLedgerRemainingParams
 * @returns remaining usable amount for a planned movementType and batchType
 * For a given ledger taking into account holding and cumulative limits. WalletLedgerRemainingLimit
 */
export const useLimitLedgerRemainingQuery = (params: FetchLimitLedgerRemainingParams, enabled = true) =>
	useQuery({
		enabled: enabled && !!(params.currencyId && params['convertAmountToCurrencies[]']?.length),
		queryFn: () => fetchLimitLedgerRemaining(params),
		queryKey: ['remainingLedgerLimits', params]
	});
